module.exports = __webpack_public_path__ + "img/belgium-external-causes-male.d45afe95.png";